import React from 'react';
import PropTypes from 'prop-types';
import { createPopup, closePopup } from '../../services/popupService';
import {
  trackEscalatedTicketWithCorrectExpertAResponse,
  trackEscalatedTicketWithWrongExpertAResponse,
  trackResolvedTicketWithCorrectExpertAResponse,
  trackResolvedTicketWithWrongExpertAResponse,
} from '../../analytics/ticketEventAnalytics';
import { PopupWrapper, NewPopupTitle, PopupImage, NewPopupSubtitle, Checkbox, CheckBoxWrapper } from './Popups.styles';
import { ButtonHolder, CommonBlueButton, DismissButton } from '../common/buttonsComponents';
import {
  EscalateMessageTextArea,
  StyledSubheading,
  ReasonDropdownSelect,
  ValidationErrorMessage,
} from './EscalatePopup/EscalatePopup.styles';
import { reasonOptions } from './EscalatePopup/EscalatePopup';

const OTHER_REASON = 'Other';
const SELECT_A_REASON = 'Select a reason';

class ExpertReviewPopup extends React.Component {
  static propTypes = {
    resolveStatus: PropTypes.bool,
    escalateStatus: PropTypes.bool,
    expertEscalation: PropTypes.func,
    expertResolve: PropTypes.func,
  };

  state = {
    reasonSelection: '',
    prevExpertAnswered: false,
    customMessage: '',
    sendButtonDisabled: false,
    hasSubmitted: false,
  };

  getValidationError() {
    if (this.state.reasonSelection === SELECT_A_REASON || !this.state.reasonSelection) {
      return 'Please provide a reason for escalation.';
    }
    if (this.state.reasonSelection === OTHER_REASON && !this.state.customMessage.trim()) {
      return 'Please specify the reason here.';
    }

    return null;
  }

  handleCheckBoxClick() {
    this.setState({ prevExpertAnswered: !this.state.prevExpertAnswered });
  }

  handleSubmitClick() {
    if (this.props.expertEscalation) {
      this.handleEscalationClick();
    } else {
      this.handleResolveClick();
    }
  }

  handleEscalationClick() {
    const { reasonSelection, prevExpertAnswered, customMessage } = this.state;
    const { ticket } = this.props;

    const escalationMessage = `Escalation Reason: ${reasonSelection} ${customMessage ? `- ${customMessage}` : ''}`;

    if (!this.getValidationError()) {
      // if previous expert answered correctly then we want to escalate the ticket to the business.
      if (prevExpertAnswered) {
        trackEscalatedTicketWithCorrectExpertAResponse();
        this.props.expertEscalation(
          escalationMessage,
          { reasonSelection, customerEmail: ticket.customerEmail, escalateToBusinessAsExpert: true },
          ticket
        );
        // If the previous expert did not answer correctly then we want to escalate the ticket to a specialist
      } else {
        trackEscalatedTicketWithWrongExpertAResponse();
        this.props.expertEscalation(escalationMessage, { reasonSelection, escalateToBusinessAsExpert: false }, ticket);
      }
      closePopup();
    }

    this.setState({ hasSubmitted: true });
  }

  handleResolveClick() {
    const { prevExpertAnswered } = this.state;
    const { ticket } = this.props;
    this.props.expertResolve(ticket.ticketId);
    if (prevExpertAnswered) {
      trackResolvedTicketWithCorrectExpertAResponse();
    } else {
      trackResolvedTicketWithWrongExpertAResponse();
    }
    closePopup();
  }

  handleDismissClick(e) {
    closePopup();
  }

  renderInfoPopup(subtitle, escalationPopup) {
    const { prevExpertAnswered } = this.state;

    return (
      <PopupWrapper>
        <NewPopupTitle>Thanks for helping with this ticket!</NewPopupTitle>
        <NewPopupSubtitle>{subtitle}</NewPopupSubtitle>
        <CheckBoxWrapper>
          <Checkbox type="checkbox" checked={prevExpertAnswered} onChange={(e) => this.handleCheckBoxClick(e)} />
          <p>Yes</p>
        </CheckBoxWrapper>
        <CheckBoxWrapper>
          <Checkbox type="checkbox" checked={!prevExpertAnswered} onChange={(e) => this.handleCheckBoxClick(e)} />
          <p>No</p>
        </CheckBoxWrapper>
        <br />
        {escalationPopup && (
          <>
            <StyledSubheading>Escalation Reason</StyledSubheading>
            <ReasonDropdownSelect
              value={this.state.reasonSelection}
              onChange={({ target: { value } }) => this.setState({ reasonSelection: value })}
            >
              <option>{'Select a reason'}</option>
              {reasonOptions.map((reason) => (
                <option key={reason}>{reason}</option>
              ))}
            </ReasonDropdownSelect>
            <EscalateMessageTextArea
              id="escalationReason"
              autoFocus
              type="text"
              placeholder={
                this.state.reasonSelection === OTHER_REASON ? 'Please specify the reason here...' : 'Anything else?'
              }
              value={this.state.customMessage}
              onChange={({ target: { value } }) => {
                this.setState({ customMessage: value });
              }}
            />
            {this.state.hasSubmitted && this.getValidationError() && (
              <ValidationErrorMessage error>
                <PopupImage src="/images/error-esclamation.svg" alt="error-icon" />
                {this.getValidationError()}
              </ValidationErrorMessage>
            )}
          </>
        )}
        <ButtonHolder>
          <DismissButton onClick={(e) => this.handleDismissClick(e)}>Dismiss</DismissButton>
          <CommonBlueButton width={'65%'} onClick={(e) => this.handleSubmitClick(e)}>
            Submit
          </CommonBlueButton>
        </ButtonHolder>
      </PopupWrapper>
    );
  }

  render() {
    const shouldShowEscalationPopup = this.props.expertEscalation ? true : false;
    const subtitle = 'Were all of the previous responses to the customer correct?';

    return this.renderInfoPopup(subtitle, shouldShowEscalationPopup);
  }
}

const showExpertReviewPopup = ({ expertReviewEscalationAction, expertReviewResolveAction, selectedTicket }) =>
  createPopup({
    type: 'ExpertReviewPopup',
    title: null,
    content: (
      <ExpertReviewPopup
        expertEscalation={expertReviewEscalationAction}
        expertResolve={expertReviewResolveAction}
        ticket={selectedTicket}
      />
    ),
    noOverlay: false,
    closeOnOutsideClick: true,
  });

export default showExpertReviewPopup;
